<template>
    <div id="favorite-resources">
        <div class="header">
            <div class="header__top">
                <span class="header__back" @click="redirectPage('operator/menu/resources')">
                    <BackIcon />
                </span>
                <span class="header__title">{{ $t("FavoriteResources") }}</span>
            </div>
            <!-- <div class="header__tabs">
                <div
                    :class="['tab', currentTab === 'manual' ? 'active' : '']"
                    @click="currentTab = 'manual'"
                >
                    {{ windowWidth > 480 ? $t("ManualAppointment") : "Manual" }}
                </div>
                <div
                    :class="['tab', currentTab === 'auto' ? 'active' : '']"
                    @click="currentTab = 'auto'"
                >
                    {{ windowWidth > 480 ? $t("AutomaticAppointment") : $t("Automatic") }}
                </div>
            </div> -->
        </div>
        <div class="body__cards">
            <div class="cards">
                <ResourceAppointmentCard v-for="resource in resourceList" :key="`${resource.resourceId}-${resource.operationId || 0}`" :resource="resource"
                    favoritePage :siteId="currentSite" @selectCard="handleSelectResourceCard"
                    @changeFavorite="handleChangeFavorite" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import ResourceAppointmentCard from "./components/Resources/ResourceAppointmentCard.vue";

export default {
    components: {
        ResourceAppointmentCard,
        BackIcon: () => import("@/assets/images/icons/back.svg")
    },
    data() {
        return {
            currentTab: "manual",
            resourceList: [],
            currentSite: this.$cookies.get("userInfo").currentSite
        };
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        redirectPage(route) {
            const prefix = localStorage.getItem("prefix") || this.$route.params.prefix;

            if (typeof route === "string") {
                this.$router.push({ path: `/${prefix}/${route}` });
            } else if (typeof route === "object" && route !== null) {
                route.params = { ...(route.params || {}), prefix };
                this.$router.push(route);
            }
        },
        getFavoriteResources() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            // const appointmentType = this.currentTab === "manual" ? 1 : 2;
            this.$http2
                .get(
                    `/api/mysfc/resources/favorites?siteId=${this.currentSite}`
                )
                .then((res) => {
                    this.resourceList = res.data;
                    this.UPDATE_FLAG_SHOW_OVERLAY(false);
                });
        },
        handleSelectResourceCard(resource) {
            if (resource && (resource.isExtrusionFlow || resource.IsExtrusionFlow)) {
                this.$bvToast?.toast(
                    "Recurso de Extrusão: Apontamento disponível exclusivamente no menu Extrusão e Fornos.",
                    {
                        title: "Fluxo de Extrusão",
                        variant: "warning",
                        solid: true
                    }
                );
                return;
            }

            this.redirectPage({
                name: "operator-point-resource",
                params: {
                    order_id: resource.orderId,
                    resource_id: resource.resourceId,
                    material_id: resource.materialId,
                    max_orders: resource.maxOrders,
                    current_order: 1
                },
                query: {
                    fromFavorite: true
                }
            });
        },
        handleChangeFavorite(resourceId) {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            this.$http2
                .post(`/api/mysfc/resource/${resourceId}/favorite?siteId=${this.currentSite}`)
                .then(() => {
                    this.getFavoriteResources();
                });
        }
    },
    mounted() {
        this.getFavoriteResources();
    },
    computed: {
        ...mapGetters("app", ["windowWidth"])
    },
    watch: {
        currentTab() {
            this.getFavoriteResources();
        }
    }
};
</script>

<style lang="scss">
.app-content-operator:has(#favorite-resources) {
    padding: 0 !important;
}

#favorite-resources {
    .header {
        background: #fff;

        .header__top {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 15.5px 29px;
            color: #4c4541;
            font-size: 22px;
            font-weight: 600;
            line-height: 30px;
            border-top: 1px solid #cfc4be;
            border-bottom: 1px solid #cfc4be;

            .header__back {
                display: flex;
                cursor: pointer;
            }
        }

        .header__tabs {
            display: flex;
            justify-content: center;

            .tab {
                color: #998f8a;
                font-size: 18px;
                font-weight: 600;
                line-height: 26px;
                text-align: center;
                cursor: pointer;
                width: 100%;
                border-bottom: 1px solid #cfc4be;
                padding: 15.5px 16px;

                &.active {
                    color: #974900;
                    border-color: #a35205;
                    box-shadow: 0px -4px 0px 0px #974900 inset;
                }
            }
        }
    }

    .body__cards {
        .cards {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            flex: 1;
            padding: 24px 29px;
            background: transparent;

            .resource-appoitment-card {
                min-width: 375px;
                max-height: fit-content;
                height: auto;
            }
        }
    }
}

@media (max-width: 834px) {
    #favorite-resources {
        .body__cards {
            .cards {
                padding: 36px 29px;

                .resource-appoitment-card {
                    min-width: 347px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #favorite-resources {
        padding-top: 49px;

        .body__cards {
            .cards {
                padding: 36px 29px;

                .resource-appoitment-card {
                    min-width: 347px;
                    width: 100%;
                }
            }
        }
    }
}

@media (max-width: 480px) {
    #favorite-resources {
        background: #fff;

        .header {
            .header__top {
                font-size: 14px;
                line-height: 20px;
                padding: 19px 16px;

                .header__back {
                    svg {
                        width: 12px;
                        height: 12px;
                    }
                }
            }
        }

        .body__cards {
            .cards {
                padding: 18px 16px;

                .resource-appoitment-card {
                    min-width: 288px;
                    width: 100%;
                }
            }
        }
    }
}
</style>
